/**
 * Ce que la rédaction a **produit** : un plan, ou l'acte.
 *
 * À ne pas confondre avec `kind`, qui dit quel *job* a tourné. Les deux ont
 * coïncidé tant que la rédaction se faisait en deux temps — `research`
 * produisait le plan détaillé, `generation` produisait l'acte — et tous les
 * libellés lus par l'avocat ont donc été écrits sur `kind`.
 *
 * **Le lancement en un seul temps casse cette coïncidence** : c'est un job
 * `research`, avec ses recherches et sa synthèse, mais ce qui atterrit dans le
 * canvas est l'acte entier. Le déroulé le savait déjà (les pastilles d'étape
 * lisent `fullDocument` et nomment la dernière « Rédaction de l'acte ») ; le
 * titre de la carte, la ligne d'insertion et le verdict final, eux, sont restés
 * sur `kind` et annonçaient un plan.
 *
 * Ce que ça coûte à l'avocat : « Plan rédigé » sous un acte de trente pages lui
 * fait attendre une étape de validation qui ne viendra jamais — l'acte EST le
 * livrable (rapporté en production le 2026-08-30).
 *
 * La règle vit ici, et pas dupliquée dans chaque afficheur : `kind` et
 * `full_document` voyagent ensemble sur les trois items de frise
 * (`session.types.ts`), donc tout composant qui rend un libellé peut la poser.
 */
export type ProductionRedigee = 'plan' | 'acte';

/**
 * @param kind Le job qui a tourné, tel que le backend l'a nommé.
 * @param fullDocument Lancement en un seul temps — `proposedPayload.full_document`.
 *   Absent sur les échanges d'historique d'avant la capacité : traité comme un
 *   déroulé en deux temps, qui est ce qu'ils étaient.
 */
export function productionRedigee(
  kind: 'research' | 'generation',
  fullDocument: boolean | undefined,
): ProductionRedigee {
  return kind === 'generation' || fullDocument === true ? 'acte' : 'plan';
}
